import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Build20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 2.5C0.25 1.80964 0.809645 1.25 1.5 1.25H18.5C19.1904 1.25 19.75 1.80964 19.75 2.5V15.5C19.75 16.1904 19.1904 16.75 18.5 16.75H16V15.25H18.25V5.75L1.75 5.75V15.25H4V16.75H1.5C0.809644 16.75 0.25 16.1904 0.25 15.5V2.5ZM18.25 2.75V4.25L4.75 4.25V2.75H18.25ZM3.25 2.75V4.25L1.75 4.25V2.75H3.25Z'
      fill='currentColor'
    />
    <path
      d='M8.75 15V19H7.25V15.8733C6.04079 15.0133 5.25 13.5994 5.25 12C5.25 10.494 5.96671 9.22425 7.07053 8.25H8.63535L9.13535 11.25H10.8647L11.3647 8.25H12.9295C14.0333 9.22425 14.75 10.494 14.75 12C14.75 13.5994 13.9592 15.0133 12.75 15.8733V19H11.25V15.0323L11.6245 14.8157C12.5978 14.2526 13.25 13.202 13.25 12C13.25 11.261 13.0039 10.58 12.5881 10.0337L12.1353 12.75H7.86465L7.41194 10.0337C6.99611 10.58 6.75 11.261 6.75 12C6.75 13.202 7.40216 14.2526 8.37554 14.8157L8.75 15Z'
      fill='currentColor'
    />
  </Svg>
);

Build20.displayName = 'Build20';
export default Build20;
